<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node), 'node-id-' + node.id]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-question-circle card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">

      <div ref="displayStatHtml"></div>

      <div class="card-data">
        <p 
          class="text-center mb-2 postback_title"
          v-if="node.data.questionType"
        >
        {{ 
          ('keyboard' === node.data.questionType) 
          ? 'Free keyboard input' 
          : 'Multiple choice' 
        }}
        </p>

        <div v-if="node.data.question" class="text_message">
          <i class="fas fa-question-circle text-primary"></i> {{ node.data.question }}
        </div>

        <div v-if="node.data.question && 'multiple' === node.data.questionType" class="ml-2 my-2">
          <div v-for="(item,index) in node.data.multipleChoices" :key="item" class="form-check">       
            <input class="form-check-input" type="radio" name="options" :id="'options'+index" :value="item">
            <label class="form-check-label" :for="'options'+index">
              {{item}}
            </label>
          </div>          
        </div>

        <div class="list-group mt-2">
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.replyType">         
            <small class="text-muted">{{ replyType }}</small>
            <p class="mb-0"> {{ node.data.replyTypeSelectedOptionText }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="('Email' === node.data.replyType) && node.data.emailQuickreply">         
            <small class="text-muted">{{ emailQuickreply }}</small>
            <p class="mb-0"> {{ quickreplyAnswer }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="('Phone' === node.data.replyType) && node.data.phoneQuickreply">         
            <small class="text-muted">{{ phoneQuickreply }}</small>
            <p class="mb-0"> {{ quickreplyAnswer }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.customField">         
            <small class="text-muted">{{ customField }}</small>
            <p class="mb-0"> {{ node.data.customFieldSelectedOptionText }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.systemField">         
            <small class="text-muted">{{ systemField }}</small>
            <p class="mb-0"> {{ node.data.systemFieldSelectedOptionText }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.assignToLabels && node.data.assignToLabels.length > 0">         
            <small class="text-muted">{{ assignToLabels }}</small>
            <p class="mb-0"> {{ node.data.assignToLabelsSelectedOptionsTextArray.join(', ') }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.assignToMessengerSequence">         
            <small class="text-muted">{{ assignToMessengerSequence }}</small>
            <p class="mb-0"> {{ node.data.assignToMessengerSequenceSelectedOptionText }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.assignToPhoneSequence">         
            <small class="text-muted">{{ assignToPhoneSequence }}</small>
            <p class="mb-0"> {{ node.data.assignToPhoneSequenceSelectedOptionText }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.skipButtonText">         
            <small class="text-muted">{{ skipButtonText }}</small>
            <p class="mb-0"> {{ node.data.skipButtonText }}</p>
          </span>
        </div>
      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div class="output text-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>
        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { lang } from '../../assets/lang'
import { templateComponentMethods, updateNodeConnections } from '../../functions/utils'

export default {
  name: 'UserInputFlowSingleTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    sec: lang.common_info_sec,
    baseUrl: window.xitFlowBuilderData.base_url,
    typing_display: lang.common_info_typing_display,

    question: lang.user_input_flow_single_template_question,
    options: lang.user_input_flow_single_template_options,
    replyType: lang.user_input_flow_single_template_reply_type,
    emailQuickreply: lang.user_input_flow_single_template_quick_reply_email,
    phoneQuickreply: lang.user_input_flow_single_template_quick_reply_phone,
    quickreplyAnswer: lang.user_input_flow_single_template_quick_reply_answer_yes,
    customField: lang.user_input_flow_single_template_custom_field,
    systemField: lang.user_input_flow_single_template_system_field,
    assignToLabels: lang.user_input_flow_single_template_assign_to_labels,
    assignToMessengerSequence: lang.user_input_flow_single_template_assign_to_messenger_sequence,
    assignToPhoneSequence: lang.user_input_flow_single_template_assign_to_email_phone_sequence,
    skipButtonText: lang.user_input_flow_single_template_skip_button_text,
    
  }),

  methods: {
    ...templateComponentMethods,
  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>

<style scoped>
.card_data_body .img-thumbnail { height: 150px; width: 250px;}
.input_content { width:50% !important;margin-top: 26px;}
.output_content{ width:50% !important;float:right !important;}
.card-sockets { padding: 5px 0 !important;}

.postback_title {
  background-color: #f6f4f4 !important;
  border-radius: 7px;
  padding: 0px 10px;
  text-transform:capitalize;
}
</style>